const PDFObject = require('pdfobject');

/*@ngInject*/
const AttachmentViewerDirective = function ($timeout, $window, coreConstant, attachmentUtil, mimeType, browserUtil, configuredFileUtil) {
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: '/ui/attachmentViewer/attachmentViewer.tpl.html',

        link: function ($scope, $elem, $attr) {

            $scope.isIE11 = browserUtil.isIE11();

            const timeoutList = [];

            let closing = 0;

            function onClosingModal() {
                closing++;
                setPdfVisibility();
            }

            function setPdfVisibility() {
                // Add timeout to ensure the scope is applied and we immediately hide/show the pdf
                timeoutList.push($timeout(function () {
                    let showPdf = !isModalOpen() || $scope.isInModal;
                    if (showPdf !== $scope.showPdf) {
                        $scope.showPdf = showPdf;
                    }
                }, 0));
            }

            function isModalOpen() {
                let modalOpen = false;
                _.each($('.modal'), function (modal) {
                    let wrappedModal = $(modal);
                    if (wrappedModal.css('visible') !== 'false' &&
                        wrappedModal.css('display') !== 'none') {
                        // If we are closing modals, ignore the number of modals currently closing
                        if (closing > 0) {
                            closing--;
                        } else {
                            modalOpen = true;
                        }
                    }
                });
                return modalOpen;
            }

            function registerInternetExplorerListeners() {
                setPdfVisibility();
                $scope.$on(coreConstant.event.MODAL_OPENED, setPdfVisibility);
                $scope.$on(coreConstant.event.MODAL_CLOSED, onClosingModal);
            }

            $attr.$observe('attachmentId', function (attachmentId) {
                if (attachmentId) {
                    attachmentUtil.getAttachmentLinkURL(attachmentId, $scope.viewModel.attachmentName).then((url) => {
                        $scope.url = url;
                        $scope.attachmentId = attachmentId;
                        processAttachment();
                    });
                }
            });

            $attr.$observe('configuredFileId', function (configuredFileId) {
                if (!_.isNil(configuredFileId)) {
                    configuredFileUtil.getConfiguredFileLinkURL(configuredFileId, $scope.viewModel.attachmentName).then((url) => {
                        $scope.url = url;
                        $scope.configuredFileId = configuredFileId;
                        processAttachment();
                    });
                }
            });

            function processAttachment() {
                if ($scope.viewModel.attachmentMimeType === mimeType.PDF || _.endsWith(_.toUpper($scope.viewModel.attachmentName), '.PDF')) {
                    $scope.viewModel.showEmbeddedPdf = true;
                    if ($scope.isIE11) {
                        registerInternetExplorerListeners();
                    } else {
                        PDFObject.embed($scope.url, '.attachmentViewerEmbed');
                    }
                } else {
                    $scope.viewModel.showEmbeddedPdf = false;
                }
            }

            $scope.$on('$destroy', function () {
                _.each(timeoutList, function (item) {
                    $timeout.cancel(item);
                });
            });

            $scope.onAttachmentOpenClick = function () {
                if (!_.isNil($scope.attachmentId)) {
                    attachmentUtil.getAttachmentLinkURL($scope.attachmentId, $scope.viewModel.attachmentName).then(function (url) {
                        $window.open(url, '_blank');
                    });
                } else if (!_.isNil($scope.configuredFileId)) {
                    configuredFileUtil.getConfiguredFileLinkURL($scope.configuredFileId, $scope.viewModel.attachmentName).then(function (url) {
                        $window.open(url, '_blank');
                    });
                }
            };
        }
    };
};

angular.module('umCore')
    .directive('attachmentViewer', AttachmentViewerDirective);
